import { render, staticRenderFns } from "./resultsGraphDFT2.vue?vue&type=template&id=66ec4ab8"
import script from "./resultsGraphDFT2.vue?vue&type=script&lang=js"
export * from "./resultsGraphDFT2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports